@if (hasEntitlements) {
  <div class="producer-login-as-employer-container">
    @if (isLoading && !clientLists) {
      <div class='loading-container'>
        <span>Loading Clients</span>
        <mat-spinner [diameter]="45"></mat-spinner>
      </div>
    }
    @if (!isLoading && !clientLists) {
      <div class='loading-container'>
        <em>There are no clients available to use the system.</em>
      </div>
    }
    @if (clientLists) {
      <form [formGroup]="loginEmpForm" #formDirective="ngForm" (submit)="submit()" class='login-emp-form'
        >
        <h2>Search by Client Name or Number</h2>
        <div class='client-form-container'>
          <div class='form-group'>
            <mat-form-field appearance="outline" class='col-md-12'>
              <mat-label>Client Name or Number</mat-label>
              <input type="text" placeholder="Client Name or Number" matInput formControlName="client"
                [matAutocomplete]="auto">
              </mat-form-field>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="clientDisplay">
                @for (client of filteredClients; track client) {
                  <mat-option [value]="client">
                    {{(client.subClientNumber || client.clientNumber) + ' - ' + client.clientName}}
                  </mat-option>
                }
              </mat-autocomplete>
            </div>
            <div class='button-container col-md-12'>
              @if (showOnlyOldButton || showBothButtons) {
                <button class="primary-btn" (click)="submtAuto(false)" type="button" mat-raised-button
                color="primary" [disabled]="!loginEmpForm.controls['client'].value?.clientId">{{oldPortalButtonLabel}}</button>
              }
              @if (isLoadingAuto) {
                <mat-spinner [diameter]="25"></mat-spinner>
              }
              @if (showOnlyNewButton || showBothButtons) {
                <button class="primary-btn" (click)="submtAuto(true)" type="button" mat-raised-button
                color="primary" [disabled]="!loginEmpForm.controls['client'].value?.clientId">{{newPortalButtonLabel}}</button>
              }
            </div>
          </div>
          <br />
          <hr />
          <br />
          <h2>Or Search By Business Type</h2>
          <div class='client-form-container'>
            <div class='form-group'>
              <mat-form-field appearance="outline" class='col-md-12'>
                <mat-label>Business Type</mat-label>
                <mat-select formControlName="businessType" required>
                  @for (option of brandData.businessTypeOptions; track option) {
                    <mat-option [value]="option">
                    {{option.label}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class='form-group'>
              @if (businessTypeSubGroupList.length) {
                <mat-form-field appearance="outline" class='col-md-12'>
                  <mat-label>{{ loginEmpForm.controls['businessType'].value?.label }}</mat-label>
                  <mat-select formControlName="businessSubGroup">
                    @for (subGroup of businessTypeSubGroupList; track subGroup) {
                      <mat-option [value]="subGroup">
                      {{subGroup.clientName}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </div>
            <div class='form-group'>
              @if (businessTypeClientList.length) {
                <mat-form-field appearance="outline" class='col-md-12'>
                  <mat-label>Client Name</mat-label>
                  <mat-select formControlName="clientDropdown" required>
                    @for (client of businessTypeClientList; track client) {
                      <mat-option [value]="client">{{client.clientName
                      || client.subClientName}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </div>
            @if (noClients) {
              <div class='form-group col-md-12'>
                <p><em>There are no clients available for this criteria.</em></p>
              </div>
            }
            <!--
            <mat-error *ngIf="reportForm.controls['reportFormat'].errors?.required">This field is required</mat-error>
            <mat-error *ngIf="reportForm.controls['reportCycle'].errors?.required">This field is required</mat-error>
            -->
            <div class='button-container col-md-12'>
              @if (showOnlyOldButton || showBothButtons) {
                <button class="primary-btn" (click)="submitCriteria(false)" type="button"
                mat-raised-button color="primary" [disabled]="!loginEmpForm?.valid || noClients">{{oldPortalButtonLabel}}</button>
              }
              @if (isLoadingCriteria) {
                <mat-spinner [diameter]="25"></mat-spinner>
              }
              @if (showOnlyNewButton || showBothButtons) {
                <button  class="primary-btn" (click)="submitCriteria(true)" type="button"
                mat-raised-button color="primary" [disabled]="!loginEmpForm?.valid || noClients">{{newPortalButtonLabel}}</button>
              }
            </div>
          </div>
        </form>
      }
    </div>
  } @else {
    <div class="loading-container warning-message">
      {{ noEntitlementsMessage || 'Your currently selected agency does not have access to log in to the Employer Portal. Try a different agency if available.'}}
    </div>
  }
